import { Routes } from '@angular/router';
import { apiAuthGuard } from '@saexpeditions/sdk/authentication';

// --- SSO Guard (comentado - reemplazado por apiAuthGuard) ---
// import { getAuth } from 'firebase/auth';
// import { authGuardFactory } from '@saexpeditions/sdk/sso';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/public/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'ui',
    loadComponent: () => import('./pages/public/ui/ui.page').then((m) => m.UiPage),
  },
  {
    path: 'secure',
    canActivate: [apiAuthGuard()],
    // --- SSO Guard (comentado) ---
    // canActivate: [authGuardFactory(() => getAuth())],
    loadChildren: () => import('./pages/secure/secure-layout.routes').then((m) => m.secureRoutes),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
